<div style="display: flex; flex-direction: column">
    <div style="flex-basis: 50%">
        <app-lazada-orders></app-lazada-orders>
    </div>
</div>
